import script from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollToTop.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollToTop.vue?vue&type=style&index=0&id=2471e3c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2471e3c9"]])

export default __exports__